import React from "react";
import { formatFecha } from "./formatFecha";

/**
 * El `id` de cada columna viaja al backend como `orderBy` (ver orderBy() en
 * DataTableHelper), asi que debe coincidir con el nombre de la columna en
 * `error_logs`. Las columnas con `button: true` quedan fuera del filtro.
 */
const Columns = (detail, destroy) => {
  const ORIGENES = {
    render: { label: "Pantalla", color: "danger" },
    window: { label: "JavaScript", color: "warning" },
    promise: { label: "Promesa", color: "info" },
  };

  return [
    {
      id: "created_at",
      name: "Fecha",
      selector: (row) => formatFecha(row.created_at),
      sortable: true,
      width: "165px",
    },
    {
      id: "origin",
      name: "Tipo",
      selector: (row) => {
        const origen = ORIGENES[row.origin] ?? {
          label: row.origin ?? "-",
          color: "secondary",
        };
        return (
          <span className={`badge bg-${origen.color}`}>{origen.label}</span>
        );
      },
      sortable: true,
      width: "110px",
    },
    {
      id: "message",
      name: "Mensaje",
      selector: (row) => row.message ?? "-",
      sortable: true,
      wrap: true,
    },
    {
      id: "route_path",
      name: "Pantalla",
      selector: (row) => row.route_path ?? "-",
      sortable: true,
      wrap: true,
      width: "180px",
    },
    {
      id: "user_email",
      name: "Usuario",
      selector: (row) => row.user_email ?? "Sin sesión",
      sortable: true,
      wrap: true,
      width: "200px",
    },
    {
      id: "route_name",
      name: "Ruta",
      selector: (row) => row.route_name ?? "-",
      sortable: true,
      wrap: true,
      width: "150px",
    },
    {
      id: "occurrences",
      name: "Veces",
      selector: (row) => row.occurrences ?? 1,
      sortable: true,
      width: "90px",
    },
    {
      id: "actions",
      name: "Acciones",
      width: "120px",
      button: true,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="pe-2">
            <button
              className="btn btn-primary btn-sm"
              title="Ver detalle del error"
              onClick={() => detail(row)}
            >
              <i className="fa fa-eye"></i>
            </button>
          </div>
          <div className="pe-2">
            <button
              className="btn btn-danger btn-sm"
              title="Eliminar registro"
              onClick={() => destroy(row.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </div>
      ),
    },
  ];
};

export default Columns;
